import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { ObjectsState } from "domain/objects/entities/interfaces/object-state.interface";
import getObjectsSearchAction from "../actions/get-objects-search.action";

const getObjectsSearchCases = (
  builder: ActionReducerMapBuilder<ObjectsState>
) => {
  builder.addCase(getObjectsSearchAction.pending, (state) => {
    state.isLoadingObjectsSearch = true;
  });

  builder.addCase(getObjectsSearchAction.fulfilled, (state, action) => {
    const newResults = action.payload?.results || [];
    const existingResults = state.objectsSearch || [];

    // Create a Map using uniqueId as key to remove duplicates
    const uniqueObjectsMap = new Map();

    // Add existing results to the map
    existingResults.forEach((obj) => {
      uniqueObjectsMap.set(obj.uniqueId, obj);
    });

    // Add new results to the map (will override if same uniqueId exists)
    newResults.forEach((obj) => {
      uniqueObjectsMap.set(obj.uniqueId, obj);
    });

    // Convert map values back to array
    state.objectsSearch = Array.from(uniqueObjectsMap.values());
    state.isLoadingObjectsSearch = false;
  });

  builder.addCase(getObjectsSearchAction.rejected, (state) => {
    state.isLoadingObjectsSearch = false;
  });
};

export default getObjectsSearchCases;
